import { getApplianceId } from "@/stores/v2/userSessionStore";
import * as clsApi from "./classroomApi";
import { errorAdapter } from "./util";

export type BypassCode = {
	id: string;
	code: string;
	created_by: string;
	creation_time: number;
	expiry_time: number;
};

export type GenerateBypassCodeResponse = {
	result: string;
};

export type GetBypassCodesResponse = {
	result: BypassCode[];
};

export type GetActiveBypassCodeResponse = {
	result: BypassCode | null;
};

export type CreateBypassCodeRequest = {
	code: string;
	creation_time: number;
	expiry_time: number;
};

export type UpdateBypassCodeRequest = {
	id: string;
	code: string;
	creation_time: number;
	expiry_time: number;
};

export type CreateBypassCodeResponse = {
	result: BypassCode;
};

export async function generateBypassCode(): Promise<GenerateBypassCodeResponse> {
	return await errorAdapter(
		clsApi.Post2<undefined, GenerateBypassCodeResponse>(`v1/appliances/${getApplianceId()}/bypass-code/generate`, undefined)
	);
}

export async function getActiveBypassCode(): Promise<GetActiveBypassCodeResponse> {
	return await errorAdapter(clsApi.Get2<GetActiveBypassCodeResponse>(`v1/appliances/${getApplianceId()}/bypass-code/active`));
}

export async function createBypassCode(body: CreateBypassCodeRequest): Promise<CreateBypassCodeResponse> {
	return await errorAdapter(
		clsApi.Put2<CreateBypassCodeRequest, CreateBypassCodeResponse>(`v1/appliances/${getApplianceId()}/bypass-code`, body)
	);
}

export async function updateBypassCode(body: UpdateBypassCodeRequest): Promise<undefined> {
	return await errorAdapter(clsApi.Post2<UpdateBypassCodeRequest, undefined>(`v1/appliances/${getApplianceId()}/bypass-code`, body));
}
